/* eslint-disable complexity */
/* eslint-disable max-depth */
/* eslint-disable no-process-env */
/* eslint-disable max-statements */
/* eslint-disable no-console */
/* eslint-disable no-undef */

import {constants} from '../util/constants';

function buildDescription(formSelection) {
    const desc = [];

    if (formSelection) {
        const strFields = ['jdsnAppSelection', 'purchaseOrder', 'partNumber', 'impactedUserFirstName', 'impactedUserMiddleInit', 'impactedUserLastName', 'impactedUserJobTitle', 'impactedUserEmail', 'impactedSupplierNumber', 'impactedSupplierName', 'supplierNumber', 'supplierName', 'appUrl', 'comments', 'phone'];

        for (const [key, val] of Object.entries(formSelection.fields)) {
            if (strFields.includes(key) && val) {
                desc.push(` ${key} - ${val}\n`);
            }
        }
    }

    return desc.join('');
}

function buildShortDescription(formSelection) {
    if (formSelection.jdsnAppSelection !== constants.EDI_REGION_TWO) {
        return formSelection.jdsnAppName;
    }
    let shortDescription = `${formSelection.jdsnAppName}`;

    shortDescription = formSelection.fields.ediR2PartNumber ? `${shortDescription} | ${formSelection.fields.ediR2PartNumber} ` : shortDescription;
    shortDescription = formSelection.fields.ediR2PurchaseOrder ? `${shortDescription} | ${formSelection.fields.ediR2PurchaseOrder}` : shortDescription;
    shortDescription = formSelection.fields.ediR2PlantCode ? `${shortDescription} | ${formSelection.fields.ediR2PlantCode}` : shortDescription;
    shortDescription = formSelection.fields.ediR2Document ? `${shortDescription} | ${formSelection.fields.ediR2Document}` : shortDescription;
    return shortDescription;
}

export const createSnowIncident = async (tokenUser, formSelection) => {
    const formData = new FormData();

    if (Array.isArray(formSelection.fields.files) && formSelection.fields.files.length > 0) {
        formSelection.fields.files.map((file) => {
            formData.append('files', file, file.name);
        });
    }
    const description = buildDescription(formSelection);
    const shortDescription = buildShortDescription(formSelection);

    formData.append('description', description);
    formData.append('shortDescription', shortDescription);
    formData.append('category', 'software');
    formData.append('subcategory', 'application');
    formData.append('urgency', '2');
    formData.append('impact', '2');
    formData.append('callerId', formSelection.fields.userId);
    formData.append('appId', formSelection.appId);
    if (formSelection.fields.customOption) {
        formData.append('customOption', formSelection.fields.customOption);
    }

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${tokenUser}`,
            'Accept': '*/*'
        },
        body: formData
    };

    return fetch(`${process.env.REACT_APP_CONTACT_US_API_URL}/contactus/post`, requestOptions).then((response) => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return response.json();
    })
        .catch((error) => {
            throw error;
        });
};
